import { Dialog, DialogTitle, IconButton, DialogActions, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { PropsWithChildren } from "react";
import { CancelButton, SubmitButton } from "@/components/intlMui";
import { useTranslation } from "@/i18n/client";
interface DialogProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  content: React.ReactNode;
  onSubmit?: () => void;
  onCancel?: () => void;
  width?: number;
  showButtonAction?: boolean;
  closeIcon?: boolean;
  rootStyles?: any;
  sx?: any;
}
export default function IntlDialog({
  open,
  onClose,
  children,
  title,
  content,
  onSubmit,
  onCancel,
  width,
  sx,
  showButtonAction = true,
  closeIcon = true,
  rootStyles,
}: PropsWithChildren<DialogProps>) {
  const { t } = useTranslation();
  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      sx={{
        "& .MuiPaper-root": {
          width: `${width || 520}px`,
          maxWidth: "1024px",
          ...(rootStyles || {}),
        },
        "& .MuiDialogTitle-root": {
          fontWeight: 700,
          lineHeight: "20px",
          fontSize: "16px",
          padding: "20px 24px 12px",
        },
        "& .dialog-icon-close": {
          fontSize: "20px",
        },
        "& .intl-dialog-content": {
          padding: "0 24px 20px",
        },
        ...sx,
      }}
    >
      {title && (
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {title}
        </DialogTitle>
      )}
      {closeIcon && (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={() => ({
            position: "absolute",
            right: 14,
            top: 10,
          })}
        >
          <CloseIcon className="dialog-icon-close" />
        </IconButton>
      )}
      <div className="intl-dialog-content">{content}</div>
      {showButtonAction && (
        <div className="dialog-footer-action">
          <CancelButton onClick={onClose}>{t("common.btnText.cancel")}</CancelButton>
          <SubmitButton autoFocus onClick={onSubmit}>
            {t("common.btnText.submit")}
          </SubmitButton>
        </div>
      )}
    </Dialog>
  );
}
